module.exports = __webpack_public_path__ + "assets/images/cYgcJyPm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noun_481825_credits.svg
// module id = 1135
// module chunks = 0